class CopyText extends  HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClick);
  }

  get changeIcon() {
    return this.hasAttribute('changeIcon');
  }

  onClick() {
    if (!navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(this.hasAttribute('data-text') ? this.getAttribute('data-text') : '').then(() => {
      if(this.changeIcon){
        this.changeIconHandle();
      }
      // copy成功后派发事件，兼容safari浏览器需要使用异步
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('copy-success'));
      }, 0);
    }).catch(() => {
      const textarea = document.createElement('textarea');
      textarea.value = this.hasAttribute('data-text') ? this.getAttribute('data-text') : '';
      textarea.readOnly = true;
      // 避免可视区域闪烁
      textarea.style.cssText = `
        position: fixed;
        left: -9999px;
        top: 0;
        opacity: 0;
      `;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const success = document.execCommand('copy');
      document.body.removeChild(textarea);
      if(this.changeIcon){
        this.changeIconHandle();
      }
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('copy-success'));
      }, 0);
    });
  }
  changeIconHandle() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="white" stroke-width="2" stroke-linejoin="round"/>
          <path d="M7.646 12.0363L10.92 15.3103L17.0839 9.14648" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`;
  }
}
customElements.define('copy-text', CopyText);